import store from '@/store';

export default {
   path: '/multicotizador/hipoteca/',
   name: 'hipoteca',
   children: [
      {
         path: 'locaciones',
         name: 'hipoteca/locaciones',
         component: () =>
            import('@/modules/hipoteca/views/LocacionesView.vue'),
         beforeEnter: (to, from, next) => {
            if (store.state.poliza.poliza.id_poliza === null) {
               store.commit('main/resetClientData');
               next('/menu');
               return;
            }
            next();
         },
      },
   ],
};
